import { tableDescription, tableLeftPane, tableLocked } from '../../engine/casino';
import { GAMES } from '../../engine/games';
import { withCommas } from '../../format';
import { Controls, Stage, StatusLine, type TableProps } from './Frame';

/** Interim view for games without their own screen yet: the engine's text,
 *  its options as buttons, and the lens gestures for games that take over
 *  the controls (Mines, Tower). */
export function GenericTable({ snapshot, actions }: TableProps) {
  const left = tableLeftPane(snapshot);
  const gestures = !!GAMES[snapshot.activeGame!].gesture && tableLocked(snapshot) && !snapshot.anim;
  return (
    <>
      <Stage className="generic" onClick={snapshot.anim ? actions.skip : undefined}>
        <div className="text-card">
          {left && <pre className="left-pane">{withCommas(left)}</pre>}
          <pre>{withCommas(tableDescription(snapshot))}</pre>
        </div>
        {gestures && (
          <div className="gestures">
            <button className="btn btn-secondary" onClick={() => actions.move('up')} aria-label="Scroll up">▲</button>
            <button className="btn btn-secondary" onClick={() => actions.move('down')} aria-label="Scroll down">▼</button>
            <button className="btn btn-primary" onClick={actions.tap}>Tap</button>
            <button className="btn btn-secondary" onClick={actions.back}>Back</button>
          </div>
        )}
        <StatusLine snapshot={snapshot} />
      </Stage>
      <Controls snapshot={snapshot} actions={actions} />
    </>
  );
}
